"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon"));

require("./Option.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Option = function Option(_ref) {
  var color = _ref.color,
      className = _ref.className,
      icon = _ref.icon,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "className", "icon", "children"]);

  var wrapperClass = 'option';
  if (color === 'success') wrapperClass += ' option--success';
  if (color === 'danger') wrapperClass += ' option--danger';
  if (className) wrapperClass += " ".concat(className);
  return _react.default.createElement("button", _extends({}, props, {
    icon: icon,
    className: wrapperClass
  }), icon ? _react.default.createElement(_Icon.default, {
    icon: icon
  }) : '', _react.default.createElement("span", null, children));
};

Option.propTypes = {
  /** Classe adicional para o wrapper */
  className: _propTypes.default.string,

  /** Ícone exibido no canto esquerdo */
  icon: _propTypes.default.string,

  /** Conteúdo HTML/Text do Componente */
  children: _propTypes.default.any.isRequired
};
var _default = Option;
exports.default = _default;